import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    current: null,
    loading: false
};

const organizationSlice = createSlice({
    name: "organization",

    initialState,

    reducers: {}
});

export default organizationSlice.reducer;
